<template lang="pug">
#home
  #first-hero.hero.is-large
    .container.mobile-padding
      img.logo(src="/images/ffc-logo.png" width="420")
      h1.is-size-1-desktop.is-size-3-touch {{ account.tagline }}
      .ctas
        router-link(:to="{ name: 'believe' }")
          span What we believe
        router-link(:to="{ name: 'services' }")
          span Watch our services
        a(@click="triggerLiveStreamModal")
          span Live stream
    scroll-indicator(v-if="!isMobile")
  .content-block.description-block
    .container.mobile-padding
      .content.has-text-centered
        p.is-size-4-desktop.is-size-5-touch We&rsquo;re Foothill Family&mdash;<br class="is-hidden-desktop"/>a non-denominational church in Southern California pastored by Mike and Beth Webb.
        p.is-size-4-desktop.is-size-5-touch Our mission is simple: <i>Building strong, Spirit-filled lives through God&rsquo;s Word.</i>
        //-p.is-size-5 We believe that the whole Bible is the inspired Word of God, that baptism in the Holy Spirit is available for every believer, and that complete salvation of spirit, soul, and body is only available through a personal relationship with Jesus Christ.
  .content-block(v-if="episodes.length > 0")
    .container
      .content-block-header.mobile-padding
        h3 Recent sermons
        router-link(:to="{ name: 'services', query: { tab: 'sermons' } }")
          span All sermons
          b-icon(icon="chevron-right")
      .columns
        .column.is-one-third(
          v-for="episode in episodes"
          :key="episode.id"
        )
          episode-list-item(
            :hoverable="true"
            :value="episode"
          )
  .content-block(v-if="tvEpisodes.length > 0")
    .container
      .content-block-header.mobile-padding
        h3 Television programs
        router-link(:to="{ name: 'tv' }")
          span MikeWebb.tv
          b-icon(icon="chevron-right")
      .columns
        .column.is-one-third(
          v-for="episode in tvEpisodes"
          :key="episode.id"
        )
          episode-list-item(
            :hoverable="true"
            :value="episode"
          )

  .hero(style="background-image:url('/images/ffc/baptism.jpg')")
    .container.mobile-padding
      h1.is-size-1 Become part of our family
      .ctas
        router-link(:to="{ name: 'ministries' }")
          span Our ministries
        router-link(:to="{ name: 'calendar' }")
          span Church calendar
        router-link(:to="{ name: 'staffMembers' }")
          span Meet our pastoral staff

  .content-block(v-if="events.length > 0")
    .container
      .content-block-header.mobile-padding
        h3 Upcoming events
        router-link(:to="{ name: 'calendar' }")
          span All events
          b-icon(icon="chevron-right")
      .columns
        .column.is-one-third(
          v-for="event in events"
          :key="event.id"
        )
          event-list-item(
            :value="event"
            :hoverable="false"
            :limit="2"
          )

  //- .hero(style="background-image:url('/images/ffc/hills.jpg')")
  //-   .container
  //-     h1.is-size-1 In the heart of Orange County
  //-     .ctas
  //-       router-link(:to="{ name: 'ministries' }")
  //-         span Our Ministries
  //-       a
  //-         span Driving Directions

  .map-block.content-block
    .container
      .columns.is-desktop
        .column.is-two-thirds
          google-map(
            :location="account._embedded.location"
            :name="account._embedded.location.id"
          )
        .column.is-one-third
          .mobile-padding
            div(style="margin-bottom:1rem;")
              h3 Location
              div.is-flex
                b-icon(icon="map-marker-outline" style="margin-right:0.35rem;")
                p(v-html="account._embedded.location.address.html")
            h3 Service times
            service-list-item(
              v-for="service in filteredServices"
              :key="service.id"
              :value="service"
            )
</template>

<script>
import { mapGetters } from 'vuex';
import _ from 'lodash';
import moment from 'moment';
import { SEARCH } from '@/utils/http';
import CollectionListItem from '@/components/collections/CollectionListItem.vue';
import EpisodeListItem from '@/components/episodes/EpisodeListItem.vue';
import EventListItem from '@/components/events/EventListItem.vue';
import GoogleMap from '@/components/GoogleMap.vue';
import LiveStreamModal from '@/components/LiveStreamModal.vue';
import ScrollIndicator from '@/components/ScrollIndicator.vue';
import ServiceListItem from '@/components/ministries/ServiceListItem.vue';
import * as actionTypes from '@/store/types/actions';
import * as getterTypes from '@/store/types/getters';

export default {
  name: 'home',
  components: {
    CollectionListItem,
    EpisodeListItem,
    EventListItem,
    GoogleMap,
    ScrollIndicator,
    ServiceListItem,
  },
  computed: {
    ...mapGetters({
      account: getterTypes.GET_ACCOUNT,
      channels: getterTypes.GET_CHANNELS,
    }),
    episodesQuery() {
      const payload = {
        size: 3,
        sort: [
          { pub_date: { order: 'desc' } },
          '_score',
        ],
        query: {
          bool: {
            must: [
              { match: { account_id: this.account.id } },
              { terms: { channel_ids: this.serviceChannelIds } },
            ],
            filter: [
              { term: { is_published: true } },
              { range: { pub_date: { lte: this.today } } },
            ],
          },
        },
      };
      return payload;
    },
    eventsQuery() {
      const payload = {
        size: 3,
        sort: [
          { end_date: { order: 'asc' } },
          { 'title.raw': { order: 'asc' } },
          '_score',
        ],
        query: {
          bool: {
            must: [
              { match: { type: 'event' } },
              { match: { account_id: this.account.id } },
              { match: { is_published: true } },
              { range: { pub_date: { lte: this.today } } },
              { range: { end_date: { gte: this.today } } },
            ],
          },
        },
      };
      return payload;
    },
    filteredServices() {
      return _.filter(this.account._embedded.services, { is_ministry_only: false });
    },
    isMobile() {
      return window.innerWidth <= 769;
    },
    serviceChannelIds() {
      const filtered = _.filter(this.channels, { is_tv: false });
      return _.map(filtered, 'id');
    },
    tvChannelIds() {
      const filtered = _.filter(this.channels, { is_tv: true });
      return _.map(filtered, 'id');
    },
    tvQuery() {
      const payload = {
        size: 3,
        sort: [
          { pub_date: { order: 'desc' } },
          '_score',
        ],
        query: {
          bool: {
            must: [
              { match: { account_id: this.account.id } },
              { terms: { channel_ids: this.tvChannelIds } },
            ],
            filter: [
              { term: { is_published: true } },
              { range: { pub_date: { lte: this.today } } },
            ],
          },
        },
      };
      return payload;
    },
    years() {
      return new Date().getFullYear() - 1986;
    },
  },
  async created() {
    this.settings.loading = true;
    this.today = moment().format('YYYY-MM-DD');
    this.month = moment().startOf('month').format('YYYY-MM-DD');
    await this.$store.dispatch(actionTypes.DO_GET_CHANNELS, {});
    await Promise.all([
      this.getEpisodes(),
      this.getEvents(),
      this.getTVEpisodes(),
    ]);
    this.settings.loading = false;
  },
  data() {
    return {
      episodes: [],
      events: [],
      month: null,
      settings: {
        loading: false,
      },
      today: null,
      tvEpisodes: [],
    };
  },
  methods: {
    async getEpisodes() {
      const { data } = await SEARCH.post('/doxa_episodes/_search', this.episodesQuery);
      this.episodes = data.hits.hits.map(h => h._source);
      return data;
    },
    async getEvents() {
      const { data } = await SEARCH.post('/doxa_events/_search', this.eventsQuery);
      this.events = this.sortEvents(data.hits.hits.map(h => h._source));
      return data;
    },
    async getTVEpisodes() {
      const { data } = await SEARCH.post('/doxa_episodes/_search', this.tvQuery);
      this.tvEpisodes = data.hits.hits.map(h => h._source);
      return data;
    },
    sortEvents(events) {
      const today = moment();
      return _.sortBy(events, (e) => {
        const filtered = _.filter(e.dates, (d) => {
          const date = moment(d, 'YYYY-MM-DD');
          return date.isSameOrAfter(today, 'day');
        });
        return _.min(filtered);
      });
    },
    async triggerLiveStreamModal() {
      await this.$store.dispatch(actionTypes.DO_GET_SERVICES, {
        scope: 'live',
      });
      this.$buefy.modal.open({
        parent: this,
        hasModalCard: true,
        component: LiveStreamModal,
      });
    },
  },
};
</script>

<style theme="ffc" lang="scss">
#home {
  margin-top: calc(#{$navbar-height} * -1);
  .hero {
    @include hero;
    &.is-large {
      height: 100vh;
    }
    .logo {
      margin-bottom: 1.5rem;
    }
    .container {
      align-items: center;
      display: flex;
      flex-flow: column;
      justify-content: center;
    }
    .ctas {
      justify-content: center;
      margin-top: 2.5rem;
      a {
        padding: 0 0.75rem;
        font-size: 1.2rem;
        color: $white;
        span {
          border-bottom: 2px solid transparent;
        }
        &:hover {
          span {
            border-bottom: 2px solid $white;
          }
        }
      }
    }
    .scrolling-indicator {
      // margin-top: 10rem;
    }
  }
  .content-block {
    margin: 4.5rem 0;
    .content-block-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      a {
        @include link;
        margin-bottom: 0.75rem;
        display: flex;
        align-items: center;
      }
    }
    h3 {
      font-family: $heading-font;
      font-weight: 500;
      font-size: 1.25rem;
      margin-bottom: 0.75rem;
    }
    .google-map {
      height: 400px;
    }
  }
  @media (min-width: $desktop) {
    .hero {
      &#first-hero {
        background-image:url('/images/ffc/teaching-02.jpg');
      }
    }
    .description-block {
      .content {
        p:not(:last-child) {
          margin-bottom: 0.75rem;
        }
      }
    }
  }
  @media (max-width: $tablet) {
    .hero {
      background-attachment: inherit;
      background-position: center;
      background-size: cover;
      &#first-hero {
        background-image: url('/images/ffc/teaching-mobile.jpg');
      }
      .logo {
        width: 280px;
      }
      .ctas {
        margin-top: 1.5rem;
        display: flex;
        flex-flow: column;
        a {
          font-size: 1.1rem;
        }
        a + a {
          padding-top: 1rem;
        }
      }
    }
    .hero {
      .container {
        h1 {
          margin-bottom: 0;
        }
      }
    }
    .content-block {
      margin: 2.5rem 0;
      &:not(.map-block) {
        .columns {
          @include carousel;
        }
      }
      .google-map {
        height: 300px;
      }
    }
  }
}
</style>
